import { SVGProps } from './types';

const LockIcon = (props: SVGProps) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99984 2.74845C8.389 2.74845 7.08317 4.05429 7.08317 5.66512V7.74845H5.4165V5.66512C5.4165 3.13381 7.46853 1.08179 9.99984 1.08179C12.5312 1.08179 14.5832 3.13381 14.5832 5.66512V7.74845H12.9165V5.66512C12.9165 4.05429 11.6107 2.74845 9.99984 2.74845Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2918 6.91504H2.7085V18.9984H17.2918V6.91504ZM11.2502 11.7067H8.75016V14.2067H11.2502V11.7067Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { LockIcon };
